<script>
//
export let pageCopy;
export let pageTitle;
export let pageImage;
//
let theTitle;
let baseURL ="https://strapi.understory.community";
let theImg = pageImage[0];
console.log("theImg: ",theImg);
let imgURL = baseURL + theImg.formats.small.url// ""+ JSON.stringify(theImg.formats.small.url);
let alt = theImg.alternativeText;
let height;

 //
 if(pageTitle!== null){
    theTitle=pageTitle;

}else{
    theTitle="";
}
</script>

<section>
    <div class="fic--plaintext-with-image" >
        <div class="fic--plaintext-with-image_text" bind:clientHeight={height}>
            {#if theTitle !== ""}
                <h1>{@html theTitle}</h1>
            {/if}
            {@html pageCopy}

        </div>
        
        <div class="fic--plaintext-with-image_image" style="height:{height}px">
            <img src="{imgURL}" alt="{alt}"/>
        </div>
    </div>
</section>